module.exports = __webpack_public_path__ + "img/vitamins.f2bea40c.svg";